// @flow

import {hasId} from './hasId';
import type {TreeStructure} from '../typedef';

export const treeHasId = (data: TreeStructure, id: string): boolean => {
    return data.some(i => hasId(i, [id]));
};
